import { render, staticRenderFns } from "./UserCoupon.vue?vue&type=template&id=c4d74be2&scoped=true"
import script from "./UserCoupon.vue?vue&type=script&lang=js"
export * from "./UserCoupon.vue?vue&type=script&lang=js"
import style0 from "./UserCoupon.vue?vue&type=style&index=0&id=c4d74be2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d74be2",
  null
  
)

export default component.exports